import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DY_FORM_DEFAULT_CONFIG, JdDyFormComponent } from './dy-form.component';
import { FormFocusDirective } from './form-focus.directive';
import { ReactiveFormsModule } from '@angular/forms';
import { DyFormDefaultConfig } from './dy-form.interface';
import { registerLocaleData } from '@angular/common';
import zh from '@angular/common/locales/zh';
import { CustomControlDirective } from './custom-control.directive';
import { PortalModule } from '@angular/cdk/portal';
import { CustomControlComponent } from './custom-control.component';
import {MatButtonModule, MatRadioModule} from '@angular/material';
import { FormGroupComponent } from './form-group.component';
import {JdGridModule} from '../grid/jd-grid.module';
import {JdToolTipModule} from '../tool-tip/tool-tip.module';
import {JdFormModule} from '../form/form.module';
import {JdSelectModule} from '../select/jd-select.module';
import {JdSelectTableModule} from '../table-select/jd-select.module';
import {JdInputModule} from '../input/jd-input.module';
import {DisabledDirective} from './disabled.directive';
import {JdDatePickerModule} from "../date-picker/date-picker.module";
import { CustomControlOutletDirective } from './custom-control-outlet.directive';
import { CustomLabelDirective } from './custom-label.directive';
import { CustomLabelOutletDirective } from './custom-label-outlet.directive';
import {jDCheckBoxModule} from "../check-box/check-box.module";
import {LoadingSvgComponent} from "./loading-svg.component";
registerLocaleData(zh);

const EXPORTS = [
  JdDyFormComponent,
  CustomControlDirective,
  CustomControlComponent,
  CustomLabelDirective
];

@NgModule({
  imports: [
    CommonModule,
    JdInputModule,
    JdGridModule,
    JdFormModule,
    JdToolTipModule,
    ReactiveFormsModule,
    JdSelectModule,
    JdSelectTableModule,
    PortalModule,
    MatButtonModule,
    MatRadioModule,
    JdDatePickerModule,
    jDCheckBoxModule,
  ],
  declarations: [...EXPORTS,
    FormFocusDirective,
    FormGroupComponent,
    DisabledDirective,
    CustomControlOutletDirective,
    CustomLabelOutletDirective,
    LoadingSvgComponent
  ],
  exports: [...EXPORTS],
  entryComponents: [CustomControlComponent]
})
export class JdDyFormModule {
  static forRoot(config?: DyFormDefaultConfig): ModuleWithProviders {
    return {
      ngModule: JdDyFormModule,
      providers: [
        {
          provide: DY_FORM_DEFAULT_CONFIG,
          useValue: config
        }
      ]
    };
  }
}
